<div class="row provider-dashboard">
  <div class="nav_tabs_container">
    <ul>
      <li [class.active]="tabIndex === 0" data-toggle="tab" (click)="setTabIndex(0)" *ngIf="isBusinessAdmin()"><a>Business Overview</a></li>
      <li [class.active]="tabIndex === 1" data-toggle="tab" (click)="setTabIndex(1)"><a>Visits Overview</a></li>
    </ul>
  </div>

  <div class="stats-container">
    <!--Date Range Selection Block-->
    <div class="date-range-container" *ngIf="tabIndex !== 0">
      <div class="form-field custom-select" *ngIf="isMobile; else desktopView">
          <select class="form-control select" id="dateRange" (change)="onMobileDateChange($event.target.value)" [(ngModel)]="dateRange" style="height: 65px;">
            <option value="today">Today</option>
            <option value="last-week">Last Week</option>
            <option value="last-quarter">Last Quarter</option>
            <option value="custom">{{ customFromDate && customToDate ? (customFromDate | date: 'dd MMM yyyy') + ' To ' + (customToDate | date: 'dd MMM yyyy') : 'Custom' }}</option>
            </select>
            <span class="custom-arrow report-custom-arrow"></span>
        </div>

      <!-- Desktop View -->
      <ng-template #desktopView>
        <div class="date-range-selector">
          <div class="date-range-option" (click)="setDate('today')" [class.active]="dateRange == 'today'">Today</div>
          <div class="date-range-option" (click)="setDate('last-week')" [class.active]="dateRange == 'last-week'">Last Week</div>
          <div class="date-range-option" (click)="setDate('last-quarter')" [class.active]="dateRange == 'last-quarter'">Last Quarter</div>
          <div class="date-range-option" (click)="openDateRangePopup()" [class.active]="dateRange == 'custom'">
            <span *ngIf="!customFromDate || !customToDate">Custom</span>
            <span *ngIf="customFromDate && customToDate">{{ customFromDate | date: 'dd MMM yyyy' }} To {{ customToDate | date: 'dd MMM yyyy' }}</span>
          </div>
        </div>
      </ng-template>
    </div>      
    <app-date-range-popup
      *ngIf="isDateRangePopupOpen"
      [fromDate]="customFromDate"
      [toDate]="customToDate"
      (close)="closeDateRangePopup()"
      (apply)="onDateRangeApply($event)">
    </app-date-range-popup>
  
    <!--Stats Data Loader-->
    <div *ngIf="statsDataLoader" style="position: relative;margin-top: 10%;">
      <div class="adjust">
        <div class="reports-loader"></div>
      </div>
    </div>

    <!--Business, Customers and Visits Overview Block-->
    <div class="business-customers-visits-container" *ngIf="!statsDataLoader">
      <!--business overview block-->
      <div class="content active business-overview" *ngIf="tabIndex === 0">
        <div class="card-container">
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Healthcare_products.svg">
              <span (click)="+healthcareProducts?.length ? openListPopup('Healthcare Products') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ +healthcareProducts?.length || 0 }}</h1>
            <p>Healthcare products</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/FeedProducts.svg">
              <span (click)="+feedProducts?.length ? openListPopup('Feed Products') : noListView()"class="view-list-link" >View List</span>
            </div>
            <h1>{{ +feedProducts?.length || 0 }}</h1>
            <p>Feed products</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Other%20products.svg">
              <span (click)="+otherProducts?.length ? openListPopup('Other Products') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ +otherProducts?.length || 0 }}</h1>
            <p>Other products</p>
          </div>
          <div class="card" *ngIf="isBusinessAdmin()">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Managers.svg">
              <span (click)="$providerManagersList.length ? openListPopup('Managers') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ $providerManagersList.length }}</h1>
            <p>Managers</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/technicians.svg">
              <span (click)="$providerTechniciansList.length ? openListPopup('Technicians') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ $providerTechniciansList.length }}</h1>
            <p>Technicians</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Dealers.svg">
              <span (click)="+providerVisitsStats?.dealers ? openListPopup('Dealers') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ +providerVisitsStats?.dealers || 0 }}</h1>
            <p>Dealers</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Farmers.svg">
              <span (click)=" +providerVisitsStats?.farmers ? openListPopup('Farmers') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ +providerVisitsStats?.farmers || 0 }}</h1>
            <p>Farmers</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Consultants.svg">
              <span (click)="+providerVisitsStats?.smes ? openListPopup('Consultants') : noListView()" class="view-list-link">View List</span>
            </div>
            <h1>{{ +providerVisitsStats?.smes || 0 }}</h1>
            <p>Consultants</p>
          </div>
          <div class="card">
            <div class="business-cards">
              <img src="assets/img/pm_dashboard_icons/Locations.svg">
              <span></span>
            </div>
            <h1>{{ +providerVisitsStats?.sites || 0 }}</h1>
            <p>Locations</p>
          </div>
        </div>
      </div>
      <!--visits overview-->
      <div class="visits-overview" *ngIf="tabIndex === 1">
        <div class="card-container">
          <div class="visit-card">
            <div class="icon"><img src="assets/img/pm_dashboard_icons/Visits.svg"> </div>
            <div class="value">{{ +providerVisitsStats?.visits || 0 }}</div>
            <div class="label">Visits</div>
          </div>
          <div class="visit-card">
            <div class="icon"><img src="assets/img/pm_dashboard_icons/Visits%20Approved.svg"></div>
            <div class="value">{{ +providerVisitsStats?.visits_approved || 0 }}</div>
            <div class="label">Visits Approved</div>
          </div>
          <div class="visit-card">
            <div class="icon"><img src="assets/img/pm_dashboard_icons/Visits%20Declined.svg"></div>
            <div class="value">{{ +providerVisitsStats?.visits_declined || 0 }}</div>
            <div class="label">Visits Rejected</div>
          </div>
          <div class="visit-card">
            <div class="icon"><img src="assets/img/pm_dashboard_icons/Approval%20rate.svg"></div>
            <div class="value">
              {{
                (providerVisitsStats?.visits
                  ? ((+providerVisitsStats?.visits_approved || 0) / (+providerVisitsStats?.visits)) * 100
                  : 0) | number:'1.2-2'
              }}%
            </div>                            
            <div class="label">Approval Rate</div>
          </div>
        </div>
        <!--dealer card data-->
        <div class="dealer-container" style="margin-top: 2%;">
          <h2 class="dealer-title">Dealer Stats</h2>
          <div class="card-container">
            <!-- Card 1 -->
            <div class="dealer-card">
              <div class="card-header">
                <span class="dealer-label">Products Placed <p class="dealer-count">{{ +providerVisitsStats?.products_placed || 0 }}</p></span>
                <span class="view-list-link" (click)="+providerVisitsStats?.products_placed ? openListPopup('Products Placed') : noListView()">View List</span>
              </div>
              <div class="card-body">
                <div class="item">
                  <span class="item-label">Units</span>
                  <span class="item-value">{{ +providerVisitsStats?.qty_placed || 0 }}</span>
                </div>
                <div class="item">
                  <span class="item-label">Value</span>
                  <span class="item-value">₹ {{ +providerVisitsStats?.value_placed || 0 }}</span>
                </div>
              </div>
            </div>
            <!-- Card 2 -->
            <div class="dealer-card">
              <div class="card-header">
                <span class="dealer-label">Products Returned <p class="dealer-count">{{ +providerVisitsStats?.products_returned || 0 }}</p></span>
                <span class="view-list-link" (click)="+providerVisitsStats?.products_returned ? openListPopup('Products Returned') : noListView()">View List</span>
              </div>
              <div class="card-body">
                <div class="item">
                  <span class="item-label">Units</span>
                  <span class="item-value">{{ +providerVisitsStats?.qty_returned || 0 }}</span>
                </div>
                <div class="item">
                  <span class="item-label">Value</span>
                  <span class="item-value">₹ {{ +providerVisitsStats?.value_returned || 0 }}</span>
                </div>
              </div>
            </div>
            <!-- Card 3 -->
            <div class="dealer-card">
              <div class="card-header">
                <span class="dealer-label" style="margin-bottom: 15%;">Financial Overview</span>
                <span class="dealer-value"></span>
              </div>
              <div class="card-body">
                <div class="item">
                  <span class="item-label">Collections</span>
                  <span class="green">₹ {{ +providerVisitsStats?.paid || 0 }}</span>
                </div>
                <div class="item">
                  <span class="item-label">Dues</span>
                  <span class="red">₹ {{ +providerVisitsStats?.due || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--farmer and consultant-->
        <div class="farmer-container" style="margin-top: 2%;">
          <div class="card-container">
            <!-- Farmer Stats Card -->
            <div class="farmer-consultant-card">
              <div class="farmer-card-header">Farmer Stats</div>
              <div class="divider"></div>
              <div class="item">
                <span class="item-label">Harvest Data</span>
                <span class="item-value">{{ (+providerVisitsStats?.own_surveys || 0) + (+providerVisitsStats?.competitor_surveys || 0) }}</span>
              </div>
              <div class="item">
                <span class="item-label">Yours Vs Competitors ratio</span>
                <span class="item-value">{{ getRatio(providerVisitsStats?.own_surveys, providerVisitsStats?.competitor_surveys) }}</span>
              </div>
            </div>
          </div>
    
          <!-- Consultant Stats Cards -->
          <!--<div class="farmer-consultant-card consultant-card">
            <div class="consultant-header">Consultant Stats</div>
            <div  style="display: flex; gap: 20px;">
              &lt;!&ndash; Bad Status &ndash;&gt;
              <div class="status-card bad">
                <a href="#" class="view-link">View →</a>
                <div class="icon"><img src="assets/img/pm_dashboard_icons/Bad%20Products%20Icon.svg"> <span>Bad</span></div>
                <p>(12 products)</p>
              </div>
              &lt;!&ndash; Average Status &ndash;&gt;
              <div class="status-card average">
                <a href="#" class="view-link">View →</a>
                <div class="icon"><img src="assets/img/pm_dashboard_icons/Average%20products.svg"> <span>Average</span></div>
                <p>(45 products)</p>
              </div>
              &lt;!&ndash; Good Status &ndash;&gt;
              <div class="status-card good">
                <a href="#" class="view-link">View →</a>
                <div class="icon"><img src="assets/img/pm_dashboard_icons/Good%20products.svg"> <span>Good</span></div>
                <p>(78 products)</p>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="popup-overlay hidden"  (click)="closePopup()"></div>
<div class="popup-container hidden"  (click)="$event.stopPropagation()">
  <div class="popup-header">
    <h3>List of {{ isListFrom }}</h3>
    <button class="close-icon" (click)="closePopup()">&#10005;</button>
  </div>
  <div class="popup-body">
    <div *ngIf="listLoader" style="position: absolute;top: 50%;left: 50%;">
      <div class="adjust">
        <div class="reports-loader"></div>
      </div>
    </div>
    <div *ngIf="!listLoader">
      <div *ngIf="isListFrom == 'Healthcare Products' && healthcareProducts?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of healthcareProducts; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.item_name || '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Feed Products' && feedProducts?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of feedProducts; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.item_name || '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Other Products' && otherProducts?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Item name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of otherProducts; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.item_name || '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Managers' && $providerManagersList?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of $providerManagersList; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.firstName || '' }} {{ data.lastName || 'NA' }}</td>
              <td>{{ data.mobileNumber || 'NA' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Technicians' && $providerTechniciansList?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of $providerTechniciansList; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.firstName || '' }} {{ data.lastName || 'NA' }}</td>
              <td>{{ data.mobileNumber || 'NA' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Dealers' && onBoardedDealers?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of onBoardedDealers; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.firstName || '' }} {{ data.lastName || '' }}</td>
              <td>{{ data.mobileNumber || 'NA' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Farmers' && onBoardedFarmers?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of onBoardedFarmers; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.firstName || '' }} {{ data.lastName || '' }}</td>
              <td>{{ data.mobileNumber || 'NA' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Consultants' && onBoardedSMEs?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Mobile Number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of onBoardedSMEs; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.firstName || '' }} {{ data.lastName || '' }}</td>
              <td>{{ data.mobileNumber || 'NA' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Products Placed' && productsPlaced?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Product</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of productsPlaced; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.product_name || '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListFrom == 'Products Returned' && productsReturned?.length">
        <div class="table-container">
          <table class="table-bordered table-responsive-md">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Product</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of productsReturned; let i = index">
              <td>{{ i + 1}}</td>
              <td>{{ data.product_name || '' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="isListSucess" class="failure-text">
        Unable to fetch details Try again after some time
      </div>
    </div>
  </div>
</div>
